<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Contact Us</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <div class="">
            <label class="custom-font-setting mt-4"> Full Name </label> <br />
            <input type="text" class="border-white-50px custom-font-setting" value="Siti Tirta Dinar" />
            <!-- <img src="../assets/img/eye-slash.png" style="width: 22px; top: 65px; right: 55px; position: absolute;" /> -->

            <br />

            <label class="custom-font-setting mt-4"> Email </label> <br />
            <input type="text" class="border-white-50px custom-font-setting" value="sititirta@gmail.com" />
            <!-- <img src="../assets/img/eye-slash.png" style="width: 22px; top: 165px; right: 55px; position: absolute;" /> -->

            <br />

            <label class="custom-font-setting mt-4"> Feedback </label> <br />
            <input type="text" class="border-white-50px custom-font-setting" placeholder="Leave your feedback" />
            <!-- <img src="../assets/img/eye-slash.png" style="width: 22px; top: 260px; right: 55px; position: absolute;" /> -->
          </div>

          <br /><br /><br /><br /><br /><br />
          
          <CButton type="button" class="button-border-blue text-white mt-4 mb-5" block>Send</CButton>
          <br /><br />
        </div>
      
              
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        //   GoToEdit() {
        //     this.$router.push("/EditProfile");
        //   },
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>